<template >
  <div id="saleby-employee"></div>
</template>

<script>
export default {
  name: 'employee-sale-chart',
  props: ['saleData'],
  watch: {
    saleData(val) {

      this.createChart()
    }
  },
  created() {
    this.createChart()
  },
  methods: {
    createChart() {
      var pieColors = (function () {
        var colors = [],
          base = Highcharts.getOptions().colors[0],
          i;

        for (i = 0; i < 10; i += 1) {
          // Start out with a darkened base color (negative brighten), and end
          // up with a much brighter color
          colors.push(Highcharts.color(base).brighten((i - 3) / 7).get());
        }
        return colors;
      }());

      const vue = this
      var HighChartPie = $('#saleby-employee');
      if (HighChartPie.length) {
        HighChartPie.highcharts({
          credits: false, // Disable HighCharts logo
          // colors: ['green', '#4a89dc', '#3bafda', '#8A1B1D'], // Set Colors
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: null
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              colors: pieColors,
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
                distance: -50,
                filter: {
                  property: 'percentage',
                  operator: '>',
                  value: 4
                }
              }
            }
          },
          series: [{
            type: 'pie',
            colorByPoint: true,
            name: 'Sale',
            data: vue.saleData
          }]
        });
      }
    }
  }
}
</script>
